import {
  ResourceTypeModel,
  ResourceTypeModelAttributes,
  ResourceTypeModelCreateAttributes,
  ResourceTypeModelUpdateAttributes,
  ResourceTypeCollection,
} from 'src/models/ResourceTypeModel';
import { Notify } from 'quasar';
import {
  ResourceTypeAdapterInteface,
  ListResourceTypesInput as BaseListResourceTypesInput,
} from 'src/adapter/ResourceTypeAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListResourceTypesInput = BaseListResourceTypesInput;
export class ResourceTypeApiClass {
  adapter: ResourceTypeAdapterInteface;
  constructor(adapter: ResourceTypeAdapterInteface) {
    this.adapter = adapter;
  }
  async listResourceTypes(
    conditions?: ListResourceTypesInput
  ): Promise<{ total: number; data: ResourceTypeCollection }> {
    try {
      const res = await this.adapter.listResourceTypes(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (resourceType: ResourceTypeModelAttributes) =>
            new ResourceTypeModel(resourceType)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getResourceType(id: string): Promise<ResourceTypeModel> {
    try {
      const resourceType = await this.adapter.getResourceType(id);
      return new ResourceTypeModel(resourceType);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async createResourceType(
    attributes: ResourceTypeModelCreateAttributes
  ): Promise<ResourceTypeModel> {
    try {
      const resourceType = await this.adapter.createResourceType(attributes);
      Notify.create({
        type: 'positive',
        message: '作成しました',
      });
      return new ResourceTypeModel(resourceType);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async updateResourceType(
    id: string,
    attributes: ResourceTypeModelUpdateAttributes
  ): Promise<ResourceTypeModel> {
    try {
      const resourceType = await this.adapter.updateResourceType(
        id,
        attributes
      );
      Notify.create({
        type: 'positive',
        message: '更新しました',
      });
      return new ResourceTypeModel(resourceType);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async deleteResourceType(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.deleteResourceType(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
